module.exports = __webpack_public_path__ + "img/8_no.bf74e4bc.svg";